import React from 'react';

import UserForm from './UserForm';

const RightSection = ({
  spare,
  toggleSpare,
  result,
  calculated,
  consultation,
  checked,
  resetApp,
}) => (
  <div className="right-section">
    <div className="logo-space">
      <img className="logo-space__item" src="images/BC_logo_biela.png" alt="Broker_Logo" />
    </div>
    <div className="content-space">
      <div className="content-space__item">
        <h3 className="content-space__text">Mesačná splátka</h3>
        <h2 className="content-space__number">{ result !== null ? `${result.monthlyPayment}€` : '0€'}</h2>
      </div>
      <div className="content-space__item">
        {spare ? <UserForm result={result} checked={checked} resetApp={resetApp} consultation={consultation} /> : null}
      </div>
      {!calculated
        ? <div className="content-space__extra-div" />
        : !spare
          ? (
            <div className="margin-top-extra content-space__item">
              <h3 className="content-space__text">{ consultation ? 'Úver vyžaduje konzultáciu a schválenie výnimky.' : 'Vieme ako ušetriť'}</h3>
              <button type="button" onClick={toggleSpare} className="btn">{consultation ? 'Chcem konzultáciu' : 'Chcem ušetriť'}</button>
            </div>
          ) : null
      }
    </div>
  </div>
);

export default RightSection;
